<div class="col">
  <ng-container *ngIf="quiz.layout === 'row'; else grid">
    <div>
      <ng-container
        *ngFor="
          let option of quiz.quizOptions;
          trackBy: 'id' | trackByKey;
          index as idx
        "
      >
        <div
          [class.is-correct]="option?.isCorrect"
          class="row gap-2 justify-start align-items"
        >
          <ng-container *ngIf="option?.imageContent">
            <img [src]="option?.imageContent?.block?.file?.signedUrl" alt="" />
          </ng-container>
          <ng-container [ngSwitch]="option.textContent?.block?.blockType">
            <ng-container *ngSwitchCase="blockTypes.WYSIWYGBlock">
              <mat-checkbox
                type="checkbox"
                disabled
                [checked]="option?.isCorrect"
              >
                <app-wysiwyg-viewer
                  [wysiwyg]="option.textContent.block"
                ></app-wysiwyg-viewer>
              </mat-checkbox>
            </ng-container>
            <ng-container *ngSwitchCase="blockTypes.KaraokeBlock">
              <mat-checkbox
                type="checkbox"
                disabled
                [checked]="option?.isCorrect"
              >
                <app-karaoke-player
                  [block]="option.textContent.block"
                ></app-karaoke-player>
              </mat-checkbox>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #grid>
  <div class="grid-col-2">
    <ng-container
      *ngFor="
        let option of quiz.quizOptions;
        trackBy: 'id' | trackByKey;
        index as idx
      "
    >
      <div class="answer-option" [class.is-correct]="option?.isCorrect">
        <ng-container *ngIf="option?.imageContent">
          <img [src]="option?.imageContent?.block?.file?.signedUrl" alt="" />
        </ng-container>
        <ng-container [ngSwitch]="option?.textContent?.block?.blockType">
          <ng-container *ngSwitchCase="blockTypes.WYSIWYGBlock">
            <mat-checkbox
              type="checkbox"
              disabled
              [checked]="option?.isCorrect"
            >
              <app-wysiwyg-viewer
                [wysiwyg]="option.textContent.block"
              ></app-wysiwyg-viewer>
            </mat-checkbox>
          </ng-container>
          <ng-container *ngSwitchCase="blockTypes.KaraokeBlock">
            <mat-checkbox
              type="checkbox"
              disabled
              [checked]="option?.isCorrect"
            >
              <app-karaoke-player
                [block]="option.textContent.block"
              ></app-karaoke-player>
            </mat-checkbox>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>
